(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/matchen/assets/javascripts/collections/my-odds-collection.js') >= 0) return;  svs.modules.push('/modules/matchen/assets/javascripts/collections/my-odds-collection.js');
"use strict";


(function (Backbone, _, svs) {
  'use strict';

  Backbone.Collection.prototype.sortByColumn = function (sortingOptions) {
    if (sortingOptions.length) {
      this.models = this._sortByColumn(this.models, sortingOptions);
      this.trigger('sortDone', this);
    }
  };
  Backbone.Collection.prototype._sortByColumn = function (models, sortingOptions) {
    const self = this;
    let sortingKey = null;
    if (sortingOptions.length === 1) {
      sortingKey = _.first(sortingOptions);
      const sortedModels = _.sortBy(models, function (model) {
        if (sortingKey.keyParse) {
          return sortingKey.keyParse.call(this, model.get(sortingKey.key));
        }
        return model.get(sortingKey.key);
      });
      if (sortingKey.order === 'desc') {
        return sortedModels.reverse();
      }
      return sortedModels;
    }
    sortingKey = sortingOptions.shift();
    models = _.chain(models).sortBy(function (model) {
      if (sortingKey.keyParse) {
        return sortingKey.keyParse.call(this, model.get(sortingKey.key));
      }
      return model.get(sortingKey.key);
    }).groupBy(model => model.get(sortingKey.key)).toArray().value();
    if (sortingKey.order === 'desc') {
      models = models.reverse();
    }
    _.each(models, (model, index, list) => {
      list[index] = self._sortByColumn(models[index], sortingOptions);
    });
    return _.flatten(models);
  };
  const log = new svs.core.log.Logger('svs.matchen.collections.MyOdds');
  svs.matchen.collections.MyOdds = svs.matchen.collections.AllOdds.extend({
    url() {
      return "".concat(svs.core.jupiter.url(), "/draw/1/score/bet_oddslist?product=6&drawnum=").concat(this.drawNumber).concat(this.getOutcomeParams());
    },
    sortByAsc: false,
    initialize(data, options) {
      this.drawNumber = options.drawNumber;
      this.modelData = options.modelData;
    },
    parse(data) {
      if (data.error) {
        log.error('Error parsing matchen odds', data.error || data);
        return [];
      }
      if (!data.oddslist) {
        return [];
      }
      const result = [];
      const self = this;
      _.each(data.oddslist, oddsItem => {
        const outComes = oddsItem.c.split(' ');
        const results = [];
        let sortingKey = '';
        for (let i = 0; i < outComes.length; i++) {
          let r = outComes[i].split('-');

          if (r[0] === '10') {
            sortingKey += '91';
          } else if (r[0] === '0') {
            sortingKey += '00';
          } else {
            sortingKey += "".concat(parseInt(r[0], 10) * 10);
          }
          if (r[1] === '10') {
            sortingKey += '91';
          } else if (r[1] === '0') {
            sortingKey += '00';
          } else {
            sortingKey += "".concat(parseInt(r[1], 10) * 10);
          }
          r = "".concat(r[0], "-").concat(r[1]);
          if (self.modelData.get('xperten').isActive()) {
            self.modelData.attributes.results.forEach(item => {
              const itemGoals = "".concat(item.get('home'), "-").concat(item.get('away'));
              if (itemGoals === oddsItem.c) {
                results.push({
                  eventNumber: i + 1,
                  result: r
                });
              }
            });
          } else if (!self.getWeightTypeByResult(r)) {
            results.push({
              eventNumber: i + 1,
              result: r
            });
          }
        }
        if (results.length > 0) {
          result.push({
            results,
            odds: oddsItem.o,
            netSales: oddsItem.s,
            sortingKey: parseInt(sortingKey, 10)
          });
        }
      });
      return result;
    },
    getWeightTypeByResult(result) {
      if (!result) {
        return false;
      }
      const data = result.split('-');
      const home = data[0];
      const away = data[1];
      if (home > away) {
        return this.modelData.get('reductionsRegular').isHomeReduced();
      } else if (home < away) {
        return this.modelData.get('reductionsRegular').isAwayReduced();
      } else if (home === away) {
        return this.modelData.get('reductionsRegular').isDrawReduced();
      }
      return false;
    },
    getOutcomeParams() {
      const outcomesHome = [];
      const outcomesAway = [];
      for (let i = 0; i < this.modelData.get('results').models.length; i++) {
        const item = this.modelData.get('results').models[i];
        outcomesHome.push(item.get('home'));
        outcomesAway.push(item.get('away'));
      }
      const uniqHome = _.uniq(outcomesHome);
      const uniqAway = _.uniq(outcomesAway);
      return "&home1=".concat(uniqHome, "&away1=").concat(uniqAway);
    },
    comparator(model) {
      return this.sortByAsc ? parseFloat(model.get('odds')) : -parseFloat(model.get('odds'));
    }
  });
})(Backbone, _, svs);

 })(window);